import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, ['serviceType'])}` : '';
  const getProvisioningDataReport = `getProvisioningDataReport(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${getProvisioningDataReport} {
        provisioningId
        accountId
        clientId
        organization
        effectiveDate
        endDate
        status
        instanceId
        type
        serviceType
      }
    }
  `;
};
